<template>
    <div id="gp_show_head" class="gp-show-head">
        <div class="app-item-wrapper">
            <img :src="processHeadPicture" class="icon">
            <div class="info-wrapper">
                <div class="title">{{ headInfo.title }}</div>
                <div class="desc">
                    <span>
                        {{ +appHeadData.book_status === 0 ?
                        `${appHeadData.booked_num}已预约` :
                            `${appHeadData.download_num}已下载` }}
                    </span>
                    <span v-if="+appHeadData.book_status === 0">
                        {{ appHeadData.date ? `预计${appHeadData.date}上线` : '敬请期待' }}
                    </span>
                </div>
                <div class="tag-wrapper">
                    <div
                        v-for="(item, index) of headInfo.tags"
                        :key="index"
                        class="tag-item"
                    >
                        {{ item }}
                    </div>
                </div>
            </div>
        </div>
        <tieba-rank-entry
            v-if="tiebaRankEntryInfo && !$root.isFromTiebaFeed"
            :game-info="appHeadData"
            :rank-entry-info="tiebaRankEntryInfo"
        />
        <app-download-sticky
            v-if="!isReserveApp"
            :download-info="downloadInfo"
            :basic-info="basicInfo"
            :is-new-style="isNewStyle"
            @showDownloadDawer="showDownloadDawer"
        />
        <app-reserve v-else :app-doc="downloadInfo"/>
    </div>
</template>

<script>
import AppDownloadSticky from './app-download-sticky';
import AppReserve from './app-reserve';
import TiebaRankEntry from './app-tieba-rank-entry.vue';
import SafeLightIcon from 'public/assets/imgs/safe_light.png';
import UpIcon from 'public/assets/imgs/up.png';
import DownIcon from 'public/assets/imgs/down.png';
import Arti from 'public/assets/imgs/arti.png';
import Performance from 'public/assets/imgs/performance.png';
import SafeGrayIcon from 'public/assets/imgs/safe_gray.png';
import {getQueryString} from '@/utils/url';
import {convert2GIPSUrl} from '@/utils/utility';
import api from '@/api';

export default {
    components: {
        AppDownloadSticky,
        AppReserve,
        TiebaRankEntry,
    },
    props: {
        basicInfo: {
            type: Object,
            default: () => ({}),
        },
        headInfo: {
            type: Object,
            required: true,
        },
        appHeadData: {
            type: Object,
            required: true,
        },
        isReserveApp: {
            type: Boolean,
            required: true,
        },
        downloadInfo: {
            type: Object,
            required: true,
        },
        isNewStyle: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            SafeLightIcon,
            UpIcon,
            DownIcon,
            showDetectDetail: false,
            isReserveGame: false,
            reserveappHeadData: {},
            safeDetect: [
                {
                    icon: Arti,
                    text: '人工检测',
                },
                {
                    icon: Performance,
                    text: '性能检测',
                },
                {
                    icon: SafeGrayIcon,
                    text: '百度安全检测',
                },
            ],
            tiebaRankEntryInfo: null, // 贴吧榜单入口信息
        };
    },
    computed: {
        processHeadPicture() {
            // 原 宽 高 81
            return convert2GIPSUrl(this.headInfo.headPicture, 324, 324, 80);
        },
    },
    created() {
        this.getTiebaRankEntryData();
    },
    methods: {
        // 获取贴吧榜单入口卡片数据
        getTiebaRankEntryData() {
            api.newdetail.getTiebaRankEntryData({
                game_id: getQueryString('zoneAppId'),
            }).then(res => {
                this.tiebaRankEntryInfo = res;
            });
        },
        showDetectDetails() {
            this.showDetectDetail = !this.showDetectDetail;
            this.doDetectClickLog();
        },
        jumpPage(item) {
            location.href = 'http://gamecenter.baidu.com/static/game/rank.html?tagName=' + item + '&channelid=60048';
        },
        doDetectClickLog() {
            const {package_name, app_name, app_id, app_type} = this.appHeadData;
            const {browserVersion, browserName} = window.detailUserAgentInfo;
            this.$logger.click({
                value: 'safeTest',
                ext: {
                    id: package_name,
                    ext: {
                        gameName: app_name,
                        srcId: getQueryString('srcid') || '',
                        sid: getQueryString('sid'),
                        gameId: app_id,
                        gameType: app_type,
                        browserVersion,
                        browserName,
                    },
                    pos: '',
                },
                network: this.$wifi ? 'wifi' : '4g',
            });
        },
        showDownloadDawer() {
            this.$emit('showDownloadDawer', true);
        },
    },
};

</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/border";
    @import "~@/common/style/mixin/mixins";
    $design-width: 1242;

    @include b(show-head) {
        margin: px2rem(60) auto 0;
        .app-item-wrapper {
            display: flex;
            align-items: center;
            margin: 0 px2rem(39);
            .icon {
                display: block;
                width: px2rem(189);
                height: px2rem(189);
                border-radius: px2rem(36);
                margin-right: px2rem(36);
            }
            .info-wrapper {
                .title {
                    font-size: px2rem(57);
                    color: #1F1F1F;
                    font-weight: bold;
                }
                .desc {
                    font-size: px2rem(36);
                    color: #B8B8B8;
                    margin-bottom: px2rem(12);
                }
                .tag-wrapper {
                    display: flex;
                    .tag-item {
                        font-size: px2rem(30);
                        color: #858585;
                        padding: px2rem(6) px2rem(15);
                        background: rgba(133,133,133,0.06);
                        border: px2rem(3) solid rgba(133,133,133,0.5);
                        border-radius: px2rem(24);
                        margin-right: px2rem(12);
                    }
                }
            }
        }

        @include e(sculpture) {
            display: flex;
            justify-content: center;
            img {
                display: inline-block;
                width: px2rem(267);
                height: px2rem(267);
                border-radius: px2rem(39);
            }
        }
        @include e(title) {
            margin-top: px2rem(45);
            font-size: px2rem(54);
            color: #000;
            letter-spacing: 0;
        }
        @include e(time-online) {
            margin-top: px2rem(30);
            font-size: px2rem(42);
            color: #999;
        }
        @include e(safe) {
            font-size: px2rem(42);
            color: #37CA88;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: px2rem(30);
            img {
                width: px2rem(42);
                margin-right: px2rem(15);
            }
            span {
                margin-right: px2rem(15);
            }
            img:last-child {
                margin-right: 0;
            }
        }
        @include e(mark) {
            font-size: px2rem(42);
            color: #555;
            padding: 0 px2rem(60);
            margin-top: px2rem(20);
            .detect-item {
                display: flex;
                align-items: center;
                margin: 0;
                line-height: px2rem(99);
                img {
                    width: px2rem(50);
                    height: px2rem(50);
                    margin-right: px2rem(24);
                }
                .detected {
                    margin-left: auto;
                    color: #37CA88;
                }
            }
        }
        @include e(spantag) {
            flex-shrink: 0;
            display: inline-flex;
            align-items: center;
            img {
                margin-right: px2rem(16);
                width: px2rem(35);
                height: px2rem(42);
            }
        }
        @include e(after_) {
            display: inline-block;
            width: px2rem(6);
            height: px2rem(6);
            border-radius: px2rem(6);
            margin: px2rem(18);
            background-color: #999;
        }
        @include e(tags) {
            display: flex;
            justify-content: center;
            margin-top: px2rem(45);
        }
        @include e(tag) {
            display: inline-block;
            text-align: center;
            font-size: px2rem(39);
            color: #555;
            padding: 0 px2rem(46);
            height: px2rem(78);
            line-height: px2rem(82);
            border-radius: px2rem(39);
            background-color: #f0f0f0;
            margin: 0 px2rem(12);
        }

        @include e(section) {
            width: 100%;
            border-bottom: px2rem(18) solid #f5f5f5;
            background: #fff;

            &:last-child {
                border-bottom: none;
            }
        }
    }

</style>